import { combineReducers } from 'redux'

import auth from './auth/reducer'
import menu from './menu/reducer'
import cerc from './cerc/reducer'


export default combineReducers({
    auth,
    menu,
    cerc
})